export const getCodePoint = (ch: string) => ch.codePointAt(0);

export const isControlCharacter = (codePoint: number): boolean =>
  (codePoint >= 0x00 && codePoint <= 0x1f) || // C0
  codePoint === 0x7f || // DEL
  (codePoint >= 0x80 && codePoint <= 0x9f); // C1
